export const EXPANDED_Y = "EXPANDED_Y",
  LOG_OUT = "LOG_OUT",
  REQUIRE_AUTHENTICATOR = "REQUIRE_AUTHENTICATOR",
  LANGTAG = "LANGTAG"

export interface AppState {
  expandedY: boolean
  requireAuthenticator: boolean
  initialState?: 'signIn' | 'signUp' | 'forgotPassword'
  langtag: string
}

export type ExpandedYPayload = boolean;
export type LangtagPayload = string;

export type ExpandedYActionType = {
  type: typeof EXPANDED_Y;
  payload: ExpandedYPayload;
}

export type RequireAuthenticatorActionType = {
  type: typeof REQUIRE_AUTHENTICATOR,
  payload?: 'signIn' | 'signUp'
}

export type LogOutActionType = {
  type: typeof LOG_OUT;
}

export type LangtagActionType = {
  type: typeof LANGTAG,
  payload: LangtagPayload
}


export type AppActionsType =
  ExpandedYActionType
  | RequireAuthenticatorActionType
  | LogOutActionType
  | LangtagActionType